/**
 * Interface for report data send to players via BattleReport opcode.
 */
export interface IServerNotification{
    title: string;
    message: string;
    type: NotificationType;
    data?: string;
}

export enum NotificationType {
    Error,
    InGameAction,
    BattleReport,
    HeroXpDistribution,
    HeroAscension,
    Announcement,
    EventMessage,
}